const config = {
  API_URL: process.env ? process.env.REACT_APP_API_URL : '',
};

export default config;
